import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { useIsClient } from '../hooks/useIsClient.js';
import { atom } from 'jotai';
import { useScopedAtom } from '../providers/ScopeProvider.js';
export const portalContainerAtom = atom(void 0);
export const Portal = (props) => {
  let { portal = true, children } = props;
  let isClient = useIsClient();
  let portalTo = usePortalTo(portal);
  if (!isClient) return null;
  return portalTo ? ReactDOM.createPortal(children, portalTo) : children;
};
export const usePortalTo = (portal) => {
  let [portalContainer] = useScopedAtom(portalContainerAtom);
  if ('boolean' == typeof portal) return portal ? portalContainer : null;
  let portalTo = 'function' == typeof portal.to ? portal.to() : portal.to;
  return portalTo ?? portalContainer;
};
